import { createApp } from 'vue'
import App from './App.vue'
import './styles/app.css'
import './styles/buttons.css'

createApp(App).mount('#app')
